import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faExclamationCircle, faTimes, faStickyNote, faCheck } from "@fortawesome/pro-solid-svg-icons";

import { QUESTION_RESULT_STATUS } from "../../../../util/common";

import "./index.scss";

const QuestionResultStatus = ({ status }) => {
  const renderStatusIcon = () => {
    switch (status) {
      case QUESTION_RESULT_STATUS.OK:
        return <FontAwesomeIcon icon={faCheck} className="status-ok" />;
      case QUESTION_RESULT_STATUS.OK_WITH_REMARKS:
        return <FontAwesomeIcon icon={faStickyNote} className="status-ok-with-remarks" />;
      case QUESTION_RESULT_STATUS.ADVISED:
        return <FontAwesomeIcon icon={faExclamationTriangle} className="status-advised" />;
      case QUESTION_RESULT_STATUS.NECESSARY:
        return <FontAwesomeIcon icon={faExclamationCircle} className="status-necessary" />;
      case QUESTION_RESULT_STATUS.NOT_WORKED_ON:
        return <FontAwesomeIcon icon={faTimes} className="status-not-worked-on" />;
      default:
        return null;
    }
  };

  return <span className="QuestionResultStatus">{renderStatusIcon(status)}</span>;
};

export default QuestionResultStatus;
